import { render, staticRenderFns } from "./RltdStatusModal.vue?vue&type=template&id=0232d5a8&scoped=true"
import script from "./RltdStatusModal.vue?vue&type=script&lang=js"
export * from "./RltdStatusModal.vue?vue&type=script&lang=js"
import style0 from "./RltdStatusModal.vue?vue&type=style&index=0&id=0232d5a8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0232d5a8",
  null
  
)

export default component.exports